import { graphql } from '@/gql'

export const GetRecruiterCandidatesQuery = graphql(/* GraphQL */ `
  query recruiterCandidates(
    $accounts: [ID!]
    $first: Int
    $hasPendingActions: Boolean
  ) {
    recruiterCandidates(
      accounts: $accounts
      first: $first
      hasPendingActions: $hasPendingActions
    ) {
      data {
        ...RecruiterCandidateFragment
      }
    }
  }
`)

export const GetAvailableRecruiterCandidatesQuery = graphql(/* GraphQL */ `
  query availableRecruiterCandidates($accounts: [ID!], $rateType: RateType, $currency: String) {
    recruiterCandidates(accounts: $accounts, status: ACTIVE) {
      data {
        ...PitchingRecruiterCandidateFragment
      }
    }
  }
`)

export const ManagedWorkerProfileQuery = graphql(/* GraphQL */ `
  query ManagedWorkerProfile($id: ID!) {
    worker(id: $id) {
      id
      name
      firstName
      middleName
      lastName
      viewerCanEdit
      address {
        address
        postCode
        city
        state
        country {
          isoCode
        }
      }
      identification {
        dateOfBirth
        nationality
        documentType
        documentNumber
        documentExpiresAt
      }
      clients {
        id
        status
        requiresOnboarding
        requiredCustomFieldsComplete
        hasRequiredCustomFields
        hasWorkerEditableCustomFields
        company {
          id
          name
          avatar
        }
        customFieldValues {
          ...FieldableFormCustomFieldValue
        }
      }
      # ownershipIsExpired defaults to false on the schema and filters out
      # hires without an active recruiter-ownership window. Pass null to
      # include all attributed hires — the SA needs to see them regardless.
      hiresWithAttribution(ownershipIsExpired: null) {
        id
        number
        company {
          id
          name
          avatar
        }
        job {
          id
          name
        }
        endClient {
          id
          name
        }
        # Scoped to NL supplier confirmation — only compliance the SA fills here today.
        compliances(names: [NL_SUPPLIER_EMPLOYMENT_CONFIRMATION]) {
          name
          completed
          applicable
          title
          data {
            ... on ComplianceDataField {
              label
              value
            }
          }
        }
      }
    }
  }
`)

export const UpdateManagedWorkerProfileMutation = graphql(/* GraphQL */ `
  mutation UpdateManagedWorkerProfile($input: UpdateWorkerInput!) {
    updateWorker(input: $input) {
      id
    }
  }
`)

export const UpdateManagedWorkerIdentificationMutation = graphql(/* GraphQL */ `
  mutation UpdateManagedWorkerIdentification(
    $input: UpdateWorkerIdentificationInput!
  ) {
    updateWorkerIdentification(input: $input) {
      dateOfBirth
      nationality
      documentType
      documentNumber
      documentExpiresAt
    }
  }
`)
